import { Toaster } from 'react-hot-toast';
import { useTheme } from '../../contexts/ThemeContext';

export const AppToaster = () => {
    const { theme } = useTheme();

    return (
        <Toaster
            position="bottom-right"
            toastOptions={{
                style: {
                    background: theme.surface,
                    color: theme.text.primary,
                    border: `1px solid ${theme.border}`,
                },
                success: {
                    iconTheme: {
                        primary: theme.primary,
                        secondary: theme.background,
                    },
                },
                error: {
                    iconTheme: {
                        primary: theme.danger,
              
                        secondary: theme.background,
                    },
                },
            }}
        />
    );
}